import { apiClient } from './client';
import type { PaginatedResponse, ApiResponse } from '@/types';

export interface Notificacion {
  id: number;
  tipo: string;
  modulo: string;
  referencia_id: number;
  mensaje: string;
  leida: boolean;
  archivada: boolean;
  proyecto_id: number | null;
  creado_por: number | null;
  /** I-RESUMEN, bloque Bitácora — LEFT JOIN a usuarios (`notificaciones.service.ts`).
   *  `null` cuando `creado_por` es `null` (notificación del sistema). */
  creado_por_nombre: string | null;
  creado_en: string;
}

export interface CountResponse { total: number }

export interface FiltrosNotif {
  page?: number; per_page?: number;
  modulo?: string; tipo?: string;
  leida?: boolean; archivada?: boolean;
  proyecto_id?: number;
}

export const fetchNotificaciones = (f: FiltrosNotif) =>
  apiClient.get<PaginatedResponse<Notificacion>>('/notificaciones', { params: f }).then(r => r.data);

export const fetchCount = () =>
  apiClient.get<ApiResponse<CountResponse>>('/notificaciones/count').then(r => r.data.data);

export const marcarLeida = (id: number) =>
  apiClient.patch(`/notificaciones/${id}/leida`).then(r => r.data);

export const marcarTodasLeidas = () =>
  apiClient.patch('/notificaciones/marcar-todas-leidas').then(r => r.data);

export const archivarNotificaciones = (ids: number[]) =>
  apiClient.patch('/notificaciones/archivar', { ids }).then(r => r.data);
